import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';

var SvgCod = function SvgCod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.724 1.276 1.367 25.633a9.23 9.23 0 0 1-.5-1.509c-.698-2.79-.897-5.615-.864-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263l.034.013ZM6.262 30.738 30.646 6.354c.385.907.52 1.555.52 1.555.665 2.758.864 5.582.83 8.108.034 2.492-.199 5.316-.863 8.107 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23a6.764 6.764 0 0 1-.08-.032Z",
    fill: "#F2C500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.193.807.868 24.132l-.002-.008c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c2.984.026 6.01.284 8.193.807ZM7.797 31.203 31.153 7.847l.014.062c.663 2.758.862 5.582.83 8.107.032 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-2.997-.027-6.036-.287-8.203-.797Z",
    fill: "#2C97DE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12 8.342 3.738 10l.84-2.778-2.313-1.754 2.902-.06.954-2.741.953 2.742 2.902.059-2.313 1.754.84 2.778L6.12 8.342Z",
    fill: "#F2C500"
  }));
};

export default SvgCod;